/*
 * mvs-header.js
 * Monteverde Stones — Hover-open + mega-menu manager for Dawn header.
 *
 * Behaviors (desktop ≥990px only):
 *   1. Hover-open <details> dropdowns (top + second level), with a 180 ms
 *      close delay so the cursor can travel across the gap.
 *   2. Detect the PRODUCTOS top-level <li> by its anchor href. Add
 *      .mvs-mega-trigger so mvs-header.css renders its panel as a
 *      two-column mega menu (left rail = categories, right pane = grandchildren).
 *   3. Manage which left-rail child is .mvs-mega-active so the right
 *      pane defaults to the first child's grandchildren on open, then
 *      switches to whichever child the user hovers next.
 *   4. Mark left-rail children with no <details> grandchildren as .mvs-mega-leaf.
 *
 * Mobile (<990px) is a no-op so Dawn's burger drawer is unchanged.
 */
(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 990px)';
  var CLOSE_DELAY_MS = 180;

  function init() {
    var headerMenu = document.querySelector('.header__inline-menu');
    if (!headerMenu) return;

    // (1) hover-open top-level <li>s
    var topLis = headerMenu.querySelectorAll(':scope > ul > li');
    topLis.forEach(function (li) {
      attachHoverOpen(li, li.querySelector(':scope > header-menu > details, :scope > details'));
    });

    // (2) hover-open second-level <li>s
    headerMenu.querySelectorAll('.header__submenu details').forEach(function (d) {
      var li = d.closest('li');
      if (li) attachHoverOpen(li, d);
    });

    // (3) PRODUCTOS mega-menu setup
    setupMegaMenu(headerMenu);
  }

  function attachHoverOpen(li, details) {
    if (!li || !details) return;
    var closeTimer = null;

    li.addEventListener('mouseenter', function () {
      if (!window.matchMedia(DESKTOP_QUERY).matches) return;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (!details.open) details.open = true;
    });

    li.addEventListener('mouseleave', function () {
      if (!window.matchMedia(DESKTOP_QUERY).matches) return;
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (li.matches(':hover') || li.contains(document.activeElement)) return;
        details.open = false;
      }, CLOSE_DELAY_MS);
    });
  }

  function findProductosTopLi(headerMenu) {
    // Match the <li> whose top-level link points at /collections/productos
    var anchors = headerMenu.querySelectorAll(':scope > ul > li a, :scope > ul > li summary');
    for (var i = 0; i < anchors.length; i++) {
      var el = anchors[i];
      var href = (el.getAttribute('href') || '').toLowerCase();
      var text = (el.textContent || '').trim().toLowerCase();
      if (href.indexOf('/collections/productos') !== -1 || text === 'productos') {
        var li = el.closest(':scope > ul > li');
        // Walk back up to the top-level <li> child of headerMenu's <ul>
        var parent = el;
        while (parent && parent.parentElement && parent.parentElement !== headerMenu.querySelector(':scope > ul')) {
          parent = parent.parentElement;
        }
        if (parent && parent.tagName === 'LI') return parent;
      }
    }
    return null;
  }

  function setupMegaMenu(headerMenu) {
    var topLi = findProductosTopLi(headerMenu);
    if (!topLi) return;
    topLi.classList.add('mvs-mega-trigger');

    // Find the first-level submenu under PRODUCTOS — Dawn may wrap the
    // <details> in a <header-menu> custom element, so check both shapes.
    var subMenu = topLi.querySelector(':scope > details > .header__submenu, :scope > header-menu > details > .header__submenu');
    if (!subMenu) return;
    subMenu.classList.add('mvs-mega-panel');

    // Children = direct <li>s of subMenu
    var children = subMenu.querySelectorAll(':scope > li');
    if (!children.length) return;

    children.forEach(function (li) {
      li.classList.add('mvs-mega-cat');
      // Grandchildren submenu — same dual-shape lookup
      var grandSubmenu = li.querySelector(':scope > details > .header__submenu, :scope > header-menu > details > .header__submenu');
      if (grandSubmenu) {
        grandSubmenu.classList.add('mvs-mega-grand');
        li.classList.add('mvs-mega-has-grand');
      } else {
        li.classList.add('mvs-mega-leaf');
      }
    });

    // NO default active class. The right pane stays hidden until the user
    // hovers a category that actually has grandchildren. CSS `:hover` covers
    // the visual state; we still toggle `.mvs-mega-active` so the JS-driven
    // "leave panel → close all" behaviour has a single class to clear.
    children.forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        if (!window.matchMedia(DESKTOP_QUERY).matches) return;
        children.forEach(function (other) { other.classList.remove('mvs-mega-active'); });
        if (li.classList.contains('mvs-mega-has-grand')) li.classList.add('mvs-mega-active');
      });
    });

    // When the whole panel is left, clear active — entire dropdown closes
    // because Dawn's <details> hover-open delay also unsets details.open.
    subMenu.addEventListener('mouseleave', function () {
      if (!window.matchMedia(DESKTOP_QUERY).matches) return;
      setTimeout(function () {
        if (subMenu.matches(':hover') || subMenu.contains(document.activeElement)) return;
        children.forEach(function (other) { other.classList.remove('mvs-mega-active'); });
      }, 200);
    });

    // Force the inner <details> open on desktop so the grandchildren
    // markup is rendered and our CSS can absolutely-position it.
    if (window.matchMedia(DESKTOP_QUERY).matches) {
      children.forEach(function (li) {
        var d = li.querySelector(':scope > details, :scope > header-menu > details');
        if (d && !d.open) d.open = true;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* Added 2026-05-08: ensure clicks on .mvs-parent-link inside <summary>
 * navigate to the parent collection page rather than only toggling the
 * <details> disclosure. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a.mvs-parent-link');
  if (!a) return;
  // Stop propagation so <summary>'s default toggle does not consume the click
  // before the browser follows the anchor.
  e.stopPropagation();
  // Allow default — browser navigates.
}, true);
